import { useState, useCallback } from "react";

type RandomWordReturnProps = [word: string, setRandomWord: () => void];

const WORDLIST = [
  "betray",
  "burial",
  "bestow",
  "branch",
  "button",
  "worker",
  "wangle",
  "warren",
  "widely",
  "wraith",
  "quorum",
  "quarry",
  "queasy",
  "queasy",
  "quirky",
  "zodiac",
  "zephyr",
  "zenith",
  "cellar",
  "cosmos",
  "cranny",
  "curved",
  "curved",
  "regret",
  "relent",
  "repast",
  "rotten",
  "recent",
  "pickle",
  "potent",
  "perish",
  "polite",
  "patrol",
  "filial",
  "filter",
  "future",
  "forget",
  "fresco",
  "scream",
  "sloven",
  "stress",
  "serves",
  "scarce",
  "ideate",
  "intent",
  "insult",
  "indoor",
  "invite",
  "vessel",
  "verity",
  "vagary",
  "verify",
  "verify",
  "alpine",
  "entail",
  "extant",
  "latent",
  "patent",
  "penial",
  "pineal",
  "plaint",
  "planet",
  "pliant",
  "talent",
  "taxite",
  "tenail",
  "tineal",
  "xenial",
  "innate",
  "invite",
  "impose",
  "impair",
  "instal",
  "finite",
  "frolic",
  "figure",
  "freeze",
  "citrus",
  "critic",
  "crouch",
  "common",
  "menage",
  "morsel",
  "minion",
  "modern",
  "mammal",
  "unpack",
  "unlike",
  "unsafe",
  "unpack",
  "unruly",
  "master",
  "meadow",
  "menace",
  "morbid",
  "muddle",
  "marked",
  "months",
  "misery",
  "muscle",
  "morass",
  "jostle",
  "junior",
  "jockey",
  "jejune",
  "jaunty",
];
const findWord = (): string =>
  WORDLIST[Math.round(Math.random() * WORDLIST.length)].toUpperCase();

const useRandomWord = (): RandomWordReturnProps => {
  const [word, setWord] = useState<string>(findWord());
  const setRandomWord = useCallback(() => {
    setWord(findWord());
  }, [setWord]);
  return [word, setRandomWord];
};

export default useRandomWord;
